<canvas
    baseChart
    [type]="'line'"
    [data]="chartData"
    [options]="barChartOptions"
    [legend]="false"
    >
</canvas>